import { render, staticRenderFns } from "./CtrlProvedoresMultaPage.vue?vue&type=template&id=02c757cc&scoped=true"
import script from "./CtrlProvedoresMultaPage.vue?vue&type=script&lang=js"
export * from "./CtrlProvedoresMultaPage.vue?vue&type=script&lang=js"
import style0 from "./CtrlProvedoresMultaPage.vue?vue&type=style&index=0&id=02c757cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c757cc",
  null
  
)

export default component.exports